import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { defaultState, MapObjectSelectionSourceEnum } from './data/AreaDetailsState';

const slice = createSlice({
  name: 'area-details',
  initialState: defaultState,
  reducers: {
    resetAreaDetails: () => {
      return defaultState;
    },
    selectMapObject: (
      state,
      action: PayloadAction<{ id: string; source: MapObjectSelectionSourceEnum } | null>
    ) => {
      if (action.payload === null) {
        state.selectedMapObjectId = undefined;
        state.mapObjectSelectionSource = undefined;
      } else {
        state.selectedMapObjectId = action.payload.id;
        state.mapObjectSelectionSource = action.payload.source;
      }
    },
    setListViewWidth: (state, action: PayloadAction<number>) => {
      state.listViewWidth = action.payload;
    },
    setSearchKeyword: (state, action: PayloadAction<string>) => {
      state.searchKeyword = action.payload;
    },
    selectCtxMenuMapObjectId: (state, action: PayloadAction<string | null>) => {
      state.ctxMenuMapObjectId = action.payload;
    },
  },
});

export const {
  resetAreaDetails,
  selectMapObject,
  selectCtxMenuMapObjectId,
  setListViewWidth,
  setSearchKeyword,
} = slice.actions;

export default slice.reducer;
